/* eslint-disable linebreak-style */
import RenderHtmlReact from './RenderHtmlReact';

export default RenderHtmlReact;
